import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const HomePage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Carousel Images - add more as needed
  const carouselImages = [
   '/Images/SKM_5627.jpg',
    '/Images/MANGALAM9.png',
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  return (

    <div id="main-content" className="bg-gray-50 pt-[116px] sm:pt-[144px] lg:pt-[148px] -mt-40">
<section className="relative w-full h-[400px] sm:h-[450px] lg:h-[500px] overflow-hidden bg-gradient-to-r from-blue-400 to-cyan-300">

  {/* Carousel track */}
  <div
    className="w-full h-full flex transition-transform duration-500 ease-in-out"
    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
  >
    {carouselImages.map((image, index) => (
      <div key={index} className="relative w-full h-full flex-shrink-0">
        
        {/* Background Image */}
        <img
          src={image}
          alt="Banner"
          className="w-full h-full object-cover"
        />

        {/* Curved Shape on Right - Exact curve from image */}
        <svg
          className="absolute top-0 right-0 h-full w-[50%] sm:w-[45%] lg:w-[40%]"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <path
            d="
              M25,0 
              C10,20 0,35 0,50
              C0,65 10,80 25,100
              L100,100 L100,0 Z
            "
            fill="rgba(0, 90, 141, 0.8)"
          />
        </svg>
{/* TEXT Overlay - Left aligned */}
{/* <div className="absolute top-1/2 right-6 sm:right-10 lg:right-12 -translate-y-1/2 max-w-xs sm:max-w-sm lg:max-w-md text-left z-20 pr-4 opacity-90">
  <h1 className="text-white text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight drop-shadow-lg">
    Learn something new<br />
    <span className="text-black">EVERYDAY.</span>
  </h1>
  <p className="text-white mt-4 text-sm sm:text-base lg:text-lg drop-shadow-md font-medium">
    Become professionals and ready<br />to join the world.
  </p>
</div> */}

      </div>
    ))}
  </div>

  {/* Dot Navigation */}
  <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2 z-30">
    {carouselImages.map((_, index) => (
      <button
        key={index}
        onClick={() => setCurrentSlide(index)}
        className={`transition-all ${
          currentSlide === index
            ? "w-10 h-2.5 bg-white rounded-full"
            : "w-2.5 h-2.5 bg-white/60 hover:bg-white/80 rounded-full"
        }`}
      />
    ))}
  </div>

</section>
<section className="bg-white py-4 sm:py-6 relative overflow-hidden">

  {/* Decorative solid glow */}
  <div className="absolute -top-24 -left-24 w-80 h-80 bg-[#93c5fd]/30 rounded-full blur-3xl" />
  <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-[#475569]/30 rounded-full blur-3xl" />

  <div className="relative marquee-container overflow-hidden">
    <div className="marquee-content flex gap-6 animate-marquee">

      {[...Array(2)].map((_, setIndex) => (
        <React.Fragment key={setIndex}>

          {[
            { icon: "/Images/icon1.png", value: "25", label: "Cooperative Sectors", bg: "bg-[#1e40af]" },
            { icon: "/Images/icon1.png", value: "23,140", label: "All Cooperatives", bg: "bg-[#4338ca]" },
            { icon: "/Images/icon3.png", value: "4,494", label: "Primary Cooperatives", bg: "bg-[#0f766e]" },
            { icon: "/Images/icon4.png", value: "1", label: "APEX Institution", bg: "bg-[#475569]" },
            { icon: "/Images/icon5.png", value: "2,950", label: "District Level Cooperative", bg: "bg-[#1d4ed8]" },
            { icon: "/Images/icon1.png", value: "1,200", label: "Total Members", bg: "bg-[#334155]" },
            { icon: "/Images/icon3.png", value: "₹8.5 Cr", label: "Annual Turnover", bg: "bg-[#0369a1]" },
            { icon: "/Images/icon4.png", value: "48", label: "Active Schemes", bg: "bg-[#1f2937]" },
          ].map((item, i) => (
            <div
              key={i}
              className={`relative flex items-center gap-4
                         ${item.bg}
                         rounded-2xl
                         px-6 py-5
                         w-[280px] sm:w-[320px]
                         hover:-translate-y-1 hover:shadow-2xl
                         transition-all duration-300
                         flex-shrink-0`}
            >
              {/* Left solid accent (kept same shape, but invisible now) */}
              <div className="absolute left-0 top-0 h-full w-2 rounded-l-2xl bg-white/20" />

              {/* Icon */}
            <img
  src={item.icon}
  alt=""
  className="w-8 h-8 invert"
/>


              {/* Text */}
              <div className="leading-tight">
                <div className="text-xl sm:text-2xl font-extrabold text-white">
                  {item.value}
                </div>
                <div className="text-sm sm:text-base font-medium text-white/90">
                  {item.label}
                </div>
              </div>
            </div>
          ))}

        </React.Fragment>
      ))}

    </div>
  </div>

  {/* Marquee animation */}
  <style jsx>{`
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .animate-marquee {
      animation: marquee 45s linear infinite;
    }
    .marquee-content:hover {
      animation-play-state: paused;
    }
  `}</style>
</section>


    </div>
  );
};

export default HomePage;